import { connect } from "react-redux";
import Grid from "./RolesGrid";
import { actions } from "../../../../redux/modules/roles";

const mstp = (state) => ({
    ...state.roles,
    userInfo: state.login.userInfo,
})

export default connect(mstp, actions)(Grid);
